<app-mb-card class="info-card">
  <header>
    <h3>Editar información de la compañía</h3>
  </header>
  <footer [formGroup]="editCompanyForm">
    <p>Datos básicos</p>
    <div>
      <app-mb-field [title]="'Nombre comercial *'" fullwidth>
        <input type="text" placeholder="Ej.: John DOE Group" formControlName="companyComercialName"
          autocomplete="new-text">
        @if (hasError('companyComercialName')) {
          <h6 translate>
            {{ hasError('companyComercialName') === 'required' ? 'required' : hasError('companyComercialName')}}
          </h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'CIF *'" fullwidth>
        <input type="text" placeholder="Ej.: B13456781" formControlName="companyCif"
          autocomplete="new-password">
        @if (hasError('companyCif')) {
          <h6 translate>
          {{ hasError('companyCif') === 'required' ? 'required' : hasError('companyCif')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Nombre fiscal *'" fullwidth>
        <input type="text" placeholder="Ej.: John DOE SA" formControlName="companyFiscalName"
          autocomplete="new-password">
        @if (hasError('companyFiscalName')) {
          <h6 translate>
          {{ hasError('companyFiscalName') === 'required' ? 'required' : hasError('companyFiscalName')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Active'" inline>
        <input type="checkbox" formControlName="active" autocomplete="new-password">
      </app-mb-field>
    </div>
    <p>Datos de localización</p>
    <div>
      <app-mb-field [title]="'Dirección'" fullwidth>
        <input type="text" placeholder="Ej.: Calle john doe 5" formControlName="companyAddress"
          autocomplete="new-text">
        @if (hasError('companyAddress')) {
          <h6 translate>
            {{ hasError('companyAddress') === 'required' ? 'required' : hasError('companyAddress')}}
          </h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Ciudad'" fullwidth>
        <input type="text" placeholder="Ej.: Madrid" formControlName="companyCity" autocomplete="new-password">
        @if (hasError('companyCity')) {
          <h6 translate>
          {{ hasError('companyCity') === 'required' ? 'required' : hasError('companyCity')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Código postal'" fullwidth>
        <input type="text" placeholder="Ej.: 28000" formControlName="companyPostalCode"
          autocomplete="new-password">
        @if (hasError('companyPostalCode')) {
          <h6 translate>
          {{ hasError('companyPostalCode') === 'required' ? 'required' : hasError('companyPostalCode')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Provincia'" fullwidth>
        <input type="text" placeholder="Ej.: Madrid" formControlName="companyProvince" autocomplete="new-text">
        @if (hasError('companyProvince')) {
          <h6 translate>
            {{ hasError('companyProvince') === 'required' ? 'required' : hasError('companyProvince')}}
          </h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Región'" fullwidth>
        <input type="text" placeholder="Ej.: Comunidad de Madrid" formControlName="companyRegion"
          autocomplete="new-password">
        @if (hasError('companyRegion')) {
          <h6 translate>
          {{ hasError('companyRegion') === 'required' ? 'required' : hasError('companyRegion')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'País *'" fullwidth>
        <input type="text" placeholder="Ej.: España" formControlName="companyCountry"
          autocomplete="new-password">
        @if (hasError('companyCountry')) {
          <h6 translate>
          {{ hasError('companyCountry') === 'required' ? 'required' : hasError('companyCountry')}}</h6>
        }
      </app-mb-field>
    </div>
    <p>Datos de contacto</p>
    <div>
      <app-mb-field [title]="'Fax'" fullwidth>
        <input type="text" placeholder="Ej.: 999 12 34 56" formControlName="companyFax" autocomplete="new-text">
        @if (hasError('companyFax')) {
          <h6 translate>
          {{ hasError('companyFax') === 'required' ? 'required' : hasError('companyFax')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Teléfono'" fullwidth>
        <input type="text" placeholder="Ej.: 666 56 78 90 " formControlName="companyPhone"
          autocomplete="new-text">
        @if (hasError('companyPhone')) {
          <h6 translate>
          {{ hasError('companyPhone') === 'required' ? 'required' : hasError('companyPhone')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Web'" fullwidth>
        <input type="text" placeholder="Ej.: www.johndoe.com" formControlName="companyWeb"
          autocomplete="new-password">
        @if (hasError('companyWeb')) {
          <h6 translate>
          {{ hasError('companyWeb') === 'required' ? 'required' : hasError('companyWeb')}}</h6>
        }
      </app-mb-field>
      <app-mb-field [title]="'Email'" fullwidth>
        <input type="text" placeholder="Ej.: johndoe@example.com" formControlName="companyEmail"
          autocomplete="new-password">
        @if (hasError('companyEmail')) {
          <h6 translate>
          {{ hasError('companyEmail') === 'required' ? 'required' : hasError('companyEmail')}}</h6>
        }
      </app-mb-field>
    </div>
    <h6>{{ userCreationFormErrorMessage }}</h6>
    <div>
      <app-mb-button (click)="updateCompany()">Actualizar</app-mb-button>
    </div>
  </footer>
</app-mb-card>
